export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				type: "medium",
				text: "Name des Tutors",
			},
		],
	},
	{
		type: "uni",
		id: 2,
		items: [
			{
				id: 2,
				text: "Die Beratungsstunden sind insgesamt hilfreich (falls angeboten).",
			},
			{
				id: 3,
				text: "Durch die Bearbeitung der Übungsaufgaben wurde mein Verständnis der Inhalte gestärkt.",
			},
			{
				id: 4,
				text: "Die Rahmenbedingungen des Tutoriums halte ich in dieser Form für geeignet (z.B. Anwesenheitspflicht, Präsenzübung, Musterlösung, Vorrechnen).",
			},
			{
				id: 5,
				text: "Mein Tutor/Meine Tutorin war stets gut vorbereitet.",
			},
			{
				id: 6,
				text: "Mein Tutor/Meine Tutorin konnte Kompliziertes verständlich machen.",
			},
			{
				id: 7,
				text: "Mein Tutor/Meine Tutorin war in der Lage, den Hintergrund zu den Themen zu vermitteln.",
			},
			{
				id: 8,
				text: "Mein Tutor/Meine Tutorin hat, innerhalb des von dem Dozenten/der Dozentin vorgegebenen Handlungsspielraums, einen guten Job gemacht.",
			},
			{
				id: 9,
				text: "Der Schwierigkeitsgrad der Übungsaufgaben/Projekte war zu hoch.",
			},
			{
				id: 10,
				text: "Der Stoff wird innerhalb des Tutoriums anhand von Beispielen veranschaulicht.",
			},
			{
				id: 11,
				text: "Ein Bezug zwischen Theorie und Praxis/Anwendung wird innerhalb des Tutoriums hergestellt.",
			},
			{
				id: 12,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit dem / der Dozenten/in.",
			},
			{
				id: 13,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit anderen Studierenden.",
			},
			{
				id: 14,
				text: "Die Online-Termine waren gut organisiert und leicht erreichbar.",
			},
			{
				id: 15,
				text: "Die Online-Materialien (z.B. Texte, Quizzes, Videos etc.) haben wesentlich zum Verständnis der Lerninhalte beigetragen.",
			},
			{
				id: 16,
				text: "Die Möglichkeiten digitaler Lehre über traditionelle Lehre hinaus (Diskussionsforen, interaktive Aufgaben etc.) wurden gut genutzt.",
			},
			{
				id: 17,
				text: "Insgesamt waren die digitalen Elemente der Veranstaltung gut.",
			},
			{
				id: 18,
				text: "Die Veranstaltung ist ein Beispiel für gute digitale Lehre.",
			},
		],
	},
	{
		type: "text",
		id: 3,
		items: [
			{
				id: 19,
				text: "Besonders gut fand ich:",
			},
			{
				id: 20,
				text: "Störend fand ich:",
			},
			{
				id: 21,
				text: "Verbesserungsvorschläge:",
			},
		],
	},
];
